<style lang="stylus">
    .pcview-tool
        display flex
        align-items center
        user-select none
        .tool-icon
            width 24px
            height 24px
            flex-shrink 0
            cursor pointer
        .tool-new
            display flex
            align-items center
            .tool-block
                display flex
                align-items center
                justify-content center
                width 28px
                height 28px
                margin-right 12px
                border 1px solid rgba(0, 0, 0, 0.06)
                border-radius 6px
                &:nth-last-child(2)
                    margin-right 0
                &:hover
                    background rgba(242, 244, 249, 0.60)
            .tool-split
                width 1px
                height 20px
                background #e4e4e4
                margin 0 12px

        .tool-search
            display flex
            align-items center
            width 160px
            height 28px
            border-radius 6px
            border 1px solid rgba(0, 0, 0, 0.06)
            padding-left 8px
            margin-right 12px
            &:hover
                border-color #017fff
            @media screen and (max-width: 450px)
                display none
            input
                width 100%
                height 100%
                border none
                outline none
                background none
                font-size 12px
                line-height 14px
                color #222
                &::placeholder
                    color rgba(34, 34, 34, 0.40)
                    font-size 12px
                    line-height 14px
            &:focus-within
                border-color #017fff !important
        .tool-sort
            display flex
            align-items center
            width 96px
            height 28px
            border-radius 6px
            border 1px solid rgba(0, 0, 0, 0.06)
            margin-right 12px
            @media screen and (max-width: 560px)
                display none
            .z-dropdown
                display flex
                align-items center
                width 100%
                height 100%
                &:hover
                    background rgba(242, 244, 249, 0.60)
            .sort-label
                display flex
                align-items center
                width 100%
                height 100%
                padding-left 8px
                font-size 12px
                line-height 16px
                color #222
                p
                    width calc(100% - 12px)
                    Overflow()
                svg
                    width 8px
                    height 8px
                    margin-right 4px
            .sort-icon
                display flex
                align-items center
                height 100%
                border-left 1px solid rgba(0, 0, 0, 0.06)
                &:hover
                    background rgba(242, 244, 249, 0.60)
        .tool-trashbox
            display flex
            align-items center
            margin-right 12px
            .tool-btn
                &:first-child
                    margin-right 12px

        .tool-btn
            display flex
            justify-content center
            align-items center
            width 28px
            height 28px
            border-radius 6px
            border 1px solid rgba(0, 0, 0, 0.06)
            &:hover
                background rgba(242, 244, 249, 0.60)
    .dark-theme_pcview-tool
        .tool-new
            .tool-block
                border-color rgba(255, 255, 255, 0.12)
                &:hover
                    background rgba(255, 255, 255, 0.08)
            .tool-split
                background rgba(255, 255, 255, 0.12)
        .tool-search
            border-color rgba(255, 255, 255, 0.12)
            input
                color #E6E6E6
                &::placeholder
                    color rgba(255, 255, 255, 0.40)
        .tool-sort
            border-color rgba(255, 255, 255, 0.12)
            .z-dropdown
                &:hover
                    background rgba(255, 255, 255, 0.08)
            .sort-label
                color #E6E6E6
            .sort-icon
                border-color rgba(255, 255, 255, 0.12)
                &:hover
                    background rgba(255, 255, 255, 0.08)
        .tool-btn
            border-color rgba(255, 255, 255, 0.12)
            &:hover
                background rgba(255, 255, 255, 0.08)
</style>

<template>
    <div class="pcview-tool" :class="{ 'dark-theme_pcview-tool': isPCDarkMode == 2 }">
        <div class="tool-new" :title="$t('addNew')" v-show="showNewTool">
            <div class="tool-block">
                <Dropdown :data="newList" :dark="isPCDarkMode == 2" @selectData="clickNewList">
                    <img class="tool-icon" :src="iconFunc('new')" />
                </Dropdown>
            </div>

            <div v-if="!hiddenImport" class="tool-block" :title="$t('importFile')" @click="clickImport">
                <img class="tool-icon" :src="iconFunc('import')" />
            </div>

            <div class="tool-split"></div>
        </div>

        <div class="tool-search" v-show="showSearch">
            <input v-model="searchWord" type="text" :placeholder="$t('searchPlaceholder')" @keypress.enter="toSearch()" />
            <img class="tool-icon" :src="iconFunc('search')" @click="toSearch()" />
        </div>

        <div class="tool-sort" v-show="showSort">
            <Dropdown :data="sortList" :dark="isPCDarkMode == 2" @selectData="clickSortList">
                <div class="sort-label">
                    <p>{{ $t(sort) }}</p>
                    <img :src="iconFunc('arr')" />
                </div>
            </Dropdown>
            <div class="sort-icon">
                <img @click="toggleOrder" class="tool-icon" :style="{ transform: orderStr }" :src="iconFunc('arrow')" />
            </div>
        </div>

        <div class="tool-trashbox" v-show="showRecycleBtn">
            <div class="tool-btn" :title="$t('restore')" @click="clickTrashTool('recover')">
                <img class="tool-icon" :src="iconFunc('allrecover')" />
            </div>
            <div class="tool-btn" :title="$t('clear')" @click="clickTrashTool('clear')">
                <img class="tool-icon" :src="iconFunc('alldelete')" />
            </div>
        </div>

        <div class="tool-btn" v-show="showLayout" @click="toggleLayout">
            <img class="tool-icon" :src="require(`@/home/assets/pcview${isPCDarkMode == 2 ? '-dark' : ''}/${layout}-mode.svg`)" />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dropdown from "./parts/Dropdown.vue";
    @Component({
        components: {
            Dropdown,
        },
    })
    export default class Temp extends Vue {
        @Prop()
        menuIndex;
        @Prop()
        hiddenImport;
        @Prop()
        searchMode;

        get showNewTool() {
            return this.menuIndex == 0;
        }
        get showSearch() {
            return [0, 1, 2, 3, 4, 5].includes(this.menuIndex);
        }
        get showSort() {
            return !this.searchMode && [0, 4, 5].includes(this.menuIndex);
        }
        get showLayout() {
            return [0, 1, 4, 5].includes(this.menuIndex);
        }
        get showRecycleBtn() {
            return this.menuIndex == 5;
        }

        iconFunc(key) {
            return require(`@/home/assets/pcview${this.isPCDarkMode == 2 ? "-dark" : ""}/${key}.svg`);
        }

        newList = [];
        initNew() {
            this.newList = [
                {
                    label: this.$t("newFolder"),
                    value: "folder",
                },
                {
                    label: this.$t("newFile"),
                    value: "file",
                },
            ];
        }
        clickNewList(data: number) {
            this.$emit("clickNew", data);
        }
        clickImport() {
            this.$emit("clickImport");
        }

        readLocal(key, str) {
            let data = localStorage.getItem(key);
            return data == null ? str : data;
        }

        sortList = [];
        initSort() {
            if (this.menuIndex == 4) {
                this.sortList = [
                    {
                        label: this.$t("name"),
                        value: "name",
                    },
                    {
                        label: this.$t("time"),
                        value: "time",
                    },
                    {
                        label: this.$t("used"),
                        value: "used",
                    },
                ];
            } else {
                this.sortList = [
                    {
                        label: this.$t("name"),
                        value: "name",
                    },
                    {
                        label: this.$t("time"),
                        value: "time",
                    },
                    {
                        label: this.$t("size"),
                        value: "size",
                    },
                ];
            }
        }
        sort = this.readLocal("max_sort", "time");
        sortIndex = 0;
        clickSortList(data: number) {
            this.sortIndex = data;
            this.sort = this.sortList[data].value;
            localStorage.setItem("max_sort", this.sort);
            this.$emit("changeSort", this.sort);
        }
        @Watch("menuIndex")
        watchIndex(nv, ov) {
            if (nv == 4 || ov == 4) {
                this.initSort();
                this.clickSortList(this.sortIndex);
            }
            if (nv != ov) {
                this.$emit("applyOrderSort", this.order, this.sort);
            }
        }
        @Watch("lang")
        watchLang(nv, ov) {
            if (nv != ov) {
                this.$nextTick(() => {
                    this.initNew();
                    this.initSort();
                });
            }
        }

        order = this.readLocal("max_order", "0");
        get orderStr() {
            return `rotate(${parseInt(this.order)}deg)`;
        }
        toggleOrder() {
            this.order = this.order == "0" ? "180" : "0";
            localStorage.setItem("max_order", this.order);
            this.$emit("changeOrder", this.order);
        }
        doListHeadOrder(obj) {
            const { sort, order } = obj;
            if (sort != this.sort) {
                this.sort = sort;
                for (let i = 0; i < this.sortList.length; i++) {
                    if (this.sortList[i].value == sort) {
                        this.sortIndex = i;
                        break;
                    }
                }
                localStorage.setItem("max_sort", sort);
                this.$emit("changeSort", sort);
            }
            if (order != this.order) {
                this.order = order;
                localStorage.setItem("max_order", this.order);
                this.$emit("changeOrder", this.order);
            }
        }

        layout = this.readLocal("max_layoutMode", "grid");
        toggleLayout() {
            this.layout = this.layout == "grid" ? "list" : "grid";
            localStorage.setItem("max_layoutMode", this.layout);
            this.$emit("changeLayout", this.layout);
        }

        searchWord = "";
        toSearch() {
            this.$emit("toSearch", this.searchWord);
        }

        clickTrashTool(key) {
            this.$emit("clickTrashTool", key);
        }

        cleanSearch() {
            this.searchWord = "";
        }

        created() {}
        mounted() {
            this.$bus.$on("listHeadOrder", this.doListHeadOrder);
            this.$nextTick(() => {
                this.initSort();
                this.initNew();
            });
        }
        beforeDestroy() {
            this.$bus.$off("listHeadOrder", this.doListHeadOrder);
        }
    }
</script>
<i18n>
{
    "zh": {
        "addNew": "新建",
        "importFile": "导入文件",
        "searchPlaceholder": "搜索文件",
        "name": "文件名",
        "time": "时间",
        "size": "大小",
        "publishTime": "发布时间",
        "used": "使用量",
        "newFolder": "新建文件夹",
        "newFile": "新建文件",
        "restore": "全部还原",
        "clear": "清空回收站"
    },
    "en": {
        "addNew": "New",
        "importFile": "Import file",
        "searchPlaceholder": "Search File",
        "name": "Name",
        "time": "Time",
        "size": "Size",
        "publishTime": "Release time",
        "used": "Usage amount",
        "newFolder": "Folder",
        "newFile": "File",
        "restore": "Restore All",
        "clear": "Empty Recycle Bin"
    },
    "fr": {
        "addNew": "Nouveau",
        "importFile": "Importer un fichier",
        "searchPlaceholder": "Rechercher des fichiers",
        "name": "Nom",
        "time": "Temps",
        "size": "Taille",
        "publishTime": "Délai de sortie",
        "used": "Montant d'utilisation",
        "newFolder": "Dossier",
        "newFile": "Fichier",
        "restore": "Tout restaurer",
        "clear": "Vider la corbeille"
    },
    "de": {
        "addNew": "Neu erstellen",
        "importFile": "Datei importieren",
        "searchPlaceholder": "Suchen",
        "name": "Name",
        "time": "Datum",
        "size": "Größe",
        "publishTime": "Veröffentlichungsdatum",
        "used": "Nutzungsmenge",
        "newFolder": "Ordner",
        "newFile": "Datei",
        "restore": "Alles wiederherstellen",
        "clear": "Papierkorb leeren"
    },
    "jp": {
        "addNew": "新規作成",
        "importFile": "ファイルをインポート",
        "searchPlaceholder": "ファイルを検索",
        "name": "名前",
        "time": "時間",
        "size": "サイズ",
        "publishTime": "更新日時",
        "used": "使用量",
        "newFolder": "フォルダ",
        "newFile": "ファイル",
        "restore": "すべてを元に戻す",
        "clear": "ごみ箱を空にする"
    },
    "es": {
        "addNew": "Añadir",
        "importFile": "Importar archivo",
        "searchPlaceholder": "Buscar archivo",
        "name": "Nombre",
        "time": "Hora",
        "size": "Talla",
        "publishTime": "Tiempo de liberación",
        "used": "Cantidad de uso",
        "newFolder": "Carpeta",
        "newFile": "Archivo",
        "restore": "Restaurar todo",
        "clear": "Papelera vacía"
    },
    "pt": {
        "addNew": "Adicionar",
        "importFile": "Importar arquivo",
        "searchPlaceholder": "Pesquisar Ficheiro",
        "name": "Nome",
        "time": "Hora",
        "size": "Tamanho",
        "publishTime": "Tempo de lançamento",
        "used": "Quantidade de uso",
        "newFolder": "Pasta",
        "newFile": "Ficheiro",
        "restore": "Restaurar Todos",
        "clear": "Esvaziar Pasta de Reciclagem"
    },
    "it": {
        "addNew": "Aggiungi",
        "importFile": "Importa file",
        "searchPlaceholder": "Cerca File",
        "name": "Nome",
        "time": "Ora",
        "size": "Dimensione",
        "publishTime": "Tempo di rilascio",
        "used": "Importo di utilizzo",
        "newFolder": "Cartella",
        "newFile": "File",
        "restore": "Ripristina Tutti",
        "clear": "Svuota Cestino"
    },
    "tw": {
        "addNew": "新建",
        "importFile": "导入文件",
        "searchPlaceholder": "搜尋檔案",
        "name": "檔案名",
        "time": "時間",
        "size": "大小",
        "publishTime": "發佈時間",
        "used": "使用量",
        "newFolder": "資料夾",
        "newFile": "檔案",
        "restore": "全部還原",
        "clear": "清空回收站"
    },
    "kr": {
        "addNew": "새로 만들기",
        "importFile": "파일 가져오기",
        "searchPlaceholder": "파일 찾기",
        "name": "파일 이름",
        "time": "시간",
        "size": "크기",
        "publishTime": "배포시간",
        "used": "사용수",
        "newFolder": "폴더",
        "newFile": "파일",
        "restore": "모두 복원",
        "clear": "휴지통 비우기"
    }
}
</i18n>
